<template>
  <v-container fluid>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex lg12>
        <v-card class="statics-filters">
          <v-card-text class="row pt-1">
            <v-flex class="row pt-0">
              <v-layout xs12 md12>
                <v-flex xs2>
                  <v-text-field label="Identificación Beneficiario" :clearable="true" maxlength="14"
                    v-model="filters.Identificacion" max-lenght></v-text-field>
                </v-flex>
                <v-flex md2>
                          <!-- :min="getStartDate" -->
                        <date-picker
                          label="Fecha inicio"
                          :max="getEndDate"
                          @changeSave="changeFechaFin"
                          v-model="filters.FechaInicio"
                        ></date-picker>
                        </v-flex>
                        <v-flex md2>
                        <date-picker
                          label="Fecha final"
                          v-model="filters.FechaFin"
                          :max="getMaxDateFechaFin"
                          :min="getMinDateFechaFin"
                        ></date-picker>
                        </v-flex>
                <v-flex md3>
                  <v-checkbox v-model="filters.MotrarComisionesPendientes" label="Mostrar comisiones pendientes">
                  </v-checkbox>
                </v-flex>
                <v-flex md3>
                  <v-spacer></v-spacer>
                  <v-flex>
                    <v-btn color="default" small @click="search()" title="Buscar">
                      Filtrar
                    </v-btn>
                    <v-btn color="default" small @click="limpiar()" title="Limpiar">
                      Limpiar
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider style="margin:0px"></v-divider>
      <v-flex lg12>
        <v-card>
          <v-card-text class="row pt-1">
            <square-comission-list  :filters="filters" ></square-comission-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
// eslint-disable-next-line no-unused-vars
import { i18n } from "@/main";
import SquareComissionList from "./SquareComissionList";
import moment from 'moment';
import DatePicker from '@/components/DatePicker/DatePickerV2'
export default {
  computed: {
    getEndDate() {
      let date = moment(this.filters.FechaInicio);
      let newDate = date.add(3, "months");
      newDate = newDate.format("YYYY-MM-DD");
      this.maxFechaFin = newDate;
      return newDate;
    },
    getStartDate() {
      // newDate = newDate.format("YYYY-MM-DD");
      return this.filters.FechaInicio;
    },
    getMaxDateFechaFin() {
      return this.maxFechaFin;
    },
    getMinDateFechaFin() {
      return this.filters.FechaInicio;
    },
    
    getEndDatePagoComision() {
      let date = moment(this.filters.FechaInicioPagoComision);
      let newDate = date.add(3, "months");
      newDate = newDate.format("YYYY-MM-DD");
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.maxFechaFinPagoComision = newDate;
      return newDate;
    },
    getStartDatePagoComision() {
      // newDate = newDate.format("YYYY-MM-DD");
      return this.filters.FechaInicioPagoComision;
    },
    getMaxDateFechaFinPagoComision() {
      return this.maxFechaFinPagoComision;
    },
    getMinDateFechaFinPagoComision() {
      return this.filters.FechaInicioPagoComision;
    },

  },
  mounted() {
    
    let startDate = moment();
    let endDate = moment();
    startDate = startDate.subtract(30, "days");
    this.filters.FechaInicio = startDate.format("YYYY-MM-DD");
    this.filters.FechaFin = endDate.format("YYYY-MM-DD");
    this.filters.FechaInicioPagoComision = startDate.format("YYYY-MM-DD");
    this.filters.FechaFinPagoComision = endDate.format("YYYY-MM-DD");
    
    
  },

  methods: {
    nzDate: nzDate,
    changeFechaFin() {
      let date = moment(this.filters.FechaInicio);
      let newDate = date.add(3, "months");
      this.filters.FechaFin = newDate.format("YYYY-MM-DD");
    },
    changeFechaFinPagoComision() {
      let date = moment(this.filters.FechaInicioPagoComision);
      let newDate = date.add(3, "months");
      this.filters.FechaFinPagoComision = newDate.format("YYYY-MM-DD");
    },
    getSquareCommission() {
      this.$store.dispatch("getSquareCommission", this.filters);
      // this.pagination.totalItems = this.squareCommissions.TotalRegistros;
    },
    search() {
      this.getSquareCommission();
    },
   
    limpiar() {
      this.filters = {
        FechaInicio: null,
        FechaFin: null,
        Identificacion: null,
        FechaInicioPagoComision: null,
        FechaFinPagoComision: null,
        MotrarComisionesPendientes:true,
        pagination:{
          Page:1,
          Limit:5

        },
      };
      let startDate = moment();
      let endDate = moment();
      startDate = startDate.subtract(30, "days");
      this.filters.FechaInicio = startDate.format("YYYY-MM-DD");
      this.filters.FechaFin = endDate.format("YYYY-MM-DD");
      this.filters.FechaInicioPagoComision = startDate.format("YYYY-MM-DD");
      this.filters.FechaFinPagoComision = endDate.format("YYYY-MM-DD");
      this.getSquareCommission();
    },
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
  },
  components: {
    SquareComissionList,
    DatePicker
  },
  data() {
    return {
      maxFechaFin: "",
      maxFechaFinPagoComision: "",
      // nowDate: moment().format("YYYY-MM-DD"),
      filters: {
        FechaInicio: null,
        FechaFin: null,
        Identificacion: null,
        FechaInicioPagoComision: null,
        FechaFinPagoComision: null,
        MotrarComisionesPendientes:true,
        pagination:{
          Page:1,
          Limit:5

        },
      
      },
    };
  },
};
</script>
